export default {
  align: {
    type: 'string',
    default: 'full',
  },
  title: {
    type: 'string',
    default: '',
  },
  subtitle: {
    type: 'string',
    default: '',
  },
  text: {
    type: 'string',
    default: '',
  },
  image: {
    type: 'object',
    default: {
      id: '',
      src: '',
      alt: '',
    },
  },
  drop: {
    type: 'boolean',
    default: true,
  },
  link: {
    type: 'string',
    default: '',
  },
};
